import { withProps } from 'recompose'
import { getIsAnyTrailer } from 'helpers/vehicle'
import VehicleInfo from './VehicleInfo'

const withVehicleProps = withProps(({ vehicle: { vehicleType, tireFrontSize, tireRearSize } = {}}) => ({
  isTrailer: getIsAnyTrailer({ vehicleType }),
  formattedTireSize: tireRearSize ? `Front: ${tireFrontSize} Rear: ${tireRearSize}` : tireFrontSize
}))

export default withVehicleProps(VehicleInfo)
